import { useQuery } from '@tanstack/react-query';
import { Employee } from '../../../types/Employee';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchEmployee = async (uuid: string, template?: string) => {
  const config = template ? { params: { template } } : {};
  const response = await CustomAxios.get<Employee>(`employees/${uuid}`, config);
  const { data } = response;
  return data;
};

interface UseGetEmployeeByIdProps {
  uuid: string;
  enabled?: boolean;
  template?: string;
}
export function useGetEmployeeById({ uuid, enabled = true, template }: UseGetEmployeeByIdProps) {
  const query = useQuery({
    enabled: enabled,
    queryKey: [queryKeys.allEmployees, uuid],
    queryFn: () => fetchEmployee(uuid, template),
  });

  return query;
}
